import { gql } from '@apollo/client'

export const ACTIONS_QUERY = gql`
  query actions(
    $processingId: ID!
    $filter: ActionFilter
    $sortBy: ActionSort
    $limit: Int
    $page: Int
  ) {
    actions(
      processingId: $processingId
      filter: $filter
      sortBy: $sortBy
      limit: $limit
      page: $page
    ) {
      collection {
        keyword
        hint
        disputeValue
        editorActive
        claimDate
        hermineRequests {
          id
          status
          errorLog
          response
        }
        requestedInfoExpiresAt
        requestedInfoPersonalNote
        requestExpired
        requestedInfoTypes {
          id
          name
          description
          kind
          required
        }
        providedInfos {
          id
          name
          kind
          file {
            fileUrl
            fileFilename
            fileByteSize
          }
          files {
            fileUrl
            fileFilename
            fileByteSize
          }
          requestedInfoType {
            id
            name
            kind
            required
            description
          }
          freeText
          createdAt
          updatedAt
          status
        }
        providedInfoStatus
        fileNumber
        closingResult
        closingResultDetail
        closingTypeId
        closingTypeOther
        closingInfoEmailBody
        communicationViaCustomerPortal
        rightActualProcessingType
        rsvLegalArea {
          id
          title
        }
        rsvLegalAreaId
        settlementComments
        actualProcessingType {
          id
          title
          legalAdviceOnly
        }
        actualProcessingTypeId
        intendedProcessingType {
          id
          title
        }
        intendedProcessingTypeId
        contactPersonFirstname
        contactPersonLastname
        contactPersonEmail
        contactPersonPhoneNumber
        contactPersonMobileNumber
        contactPersonSalutation
        contactPersonRelationToPolicyholder
        conflictContactFirstname
        conflictContactLastname
        conflictContactEmail
        conflictContactPhoneNumber
        conflictContactMobileNumber
        conflictContactRelationToConflictPartner
        policyholderFirstname
        policyholderLastname
        policyholderEmail
        policyholderPlace
        policyholderPostalCode
        policyholderPhoneNumber
        policyholderMobileNumber
        policyholderSalutation
        policyNumber
        claimNumber
        conflictPartnerCompany
        conflictPartnerSalutation
        conflictPartnerFirstname
        conflictPartnerLastname
        conflictPartnerEmail
        conflictPartnerPhoneNumber
        conflictPartnerPlace
        conflictPartnerStreet
        conflictPartnerHouseNumber
        conflictPartnerMobileNumber
        conflictPartnerSalutation
        needsCollisionDetection
        noCollisionByHuman
        completeReason
        conflictPartnerAgreesMediation
        conflictPartnerAgreesToCoverCosts
        contactSuccessful
        contactType
        contactDirection
        costs
        costsCoveredByKp
        createdAt
        customerComments
        customerRating
        customerMessageType
        dataset
        date
        firstCall
        id
        informReason
        internalTransferReason
        note
        caseComments
        aiLegalAdvice
        legalAdvice
        mailSentAt
        sentAt
        attorneyStatus
        noMailSentReason
        attorneyReason
        attorneyType
        policyholderAgreesMediation
        closingInfoEmailScheduleAt
        closingInfoEmailCancelledAt
        cancelled
        cancellable
        processing {
          agentId
          id
          m2Case {
            id
          }
          involvedUsers {
            id
            name
          }
        }
        payment {
          id
          amount
          amountDecimal
          email
          salutation
          firstname
          lastname
          status
          stripeCheckoutUrl
          stripeReceiptUrl
          paymentRequestedAt
          paymentReceivedAt
          createdAt
          updatedAt
          user {
            email
            firstname
            lastname
            name
          }
        }
        processingId
        type
        updatedAt
        user {
          id
          name
          role
        }
        userId
        visibleForOtherProcessings
        createdViaApi
        apiSource
        visibleForPolicyholder
        resultId
        result {
          id
          title
          systemValue
          parentResultId
          parentResult {
            id
            title
            systemValue
          }
        }
        uploads {
          id
          attachmentUrl
          attachmentFilename
          attachmentSignedId
          processed
          status
          errorMessage
        }
      }
    }
  }
`
